export enum Screen {
  EXPLORE = "EXPLORE", // @deprecated
  MEDIA_MANAGER = "MEDIA_MANAGER",
  MEDIA_PERMISSION = "MEDIA_PERMISSION",
  CONTENT = "CONTENT", // @deprecated
}

export type ScreenTab<T extends Screen> = {
  id: ScreenTabsMap[T];
};

export enum ExploreTabs {
  // @deprecated
  DISCOVER = "DISCOVER",
  NEARBY = "NEARBY",
}

export enum MediaManagerTabs {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
}

export enum MediaPermissionTabs {
  REQUESTED = "REQUESTED",
  APPROVED = "APPROVED",
}

export enum ContentTabs {
  EVENTS = "EVENTS", // @deprecated
}

export type ScreenTabsMap = {
  [Screen.EXPLORE]: ExploreTabs; // @deprecated
  [Screen.MEDIA_MANAGER]: MediaManagerTabs;
  [Screen.MEDIA_PERMISSION]: MediaPermissionTabs;
  [Screen.CONTENT]: ContentTabs; // @deprecated
};
